import { ChevronRight, MoreVertical, Star, Trash } from "lucide-react";

// import {
//   DropdownMenuContent,
//   DropdownMenuItem,
// } from "@/shared/components/ui/dropdown-menu";
import { Button } from "@/shared/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";

import { Separator } from "@/shared/components/ui/separator";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import { IconPlusFile } from "@/assets/icons/svg/icon-plus-file";

import InviteSpecificationInbox from "../sections/invite-specification-inbox";
import { useDispatch, useSelector } from "@/core/redux/store";
import { InboxType } from "@/shared/services/interface/responses/IInboxResponses";
import {
  GetExploreCompletedCount,
  GetInboxDisplayTexts,
  TimeCalculator,
} from "../helper/list-item-helper";
import ActivitySection from "../sections/activity-section";
import {
  deleteInbox,
  getInbox,
  toggleFavorite,
} from "@/core/redux/thunks/inboxThunk";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  AlertDialogPortal,
} from "@/shared/components/ui/alert-dialog";
import { useState } from "react";
import { CompletedSpecificationInbox } from "../sections/completed-specification-inbox";
import AnsweringSpecificationInbox from "../sections/answering-specitication-inbox";
import { Badge } from "@/shared/components/ui/badge";

export function MailDisplay() {
  const { t } = useTranslation();
  const selectedInbox = useSelector((state) => state.inbox.selectedInbox);
  const dispatch = useDispatch();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const me = useSelector((state) => state.user.me);

  if (!selectedInbox) return;

  const { title, description = "" } = GetInboxDisplayTexts(
    selectedInbox?.type,
    selectedInbox?.metadata || {},
    t,
    me?.id === selectedInbox?.metadata?.sendedBy?.id
  );

  const handleToggleFavorite = () => {
    dispatch(toggleFavorite(selectedInbox.id));
  };

  const handleDelete = async () => {
    if (!me) return;
    setIsDeleteDialogOpen(false);
    const response = await dispatch(deleteInbox(selectedInbox.id)).unwrap();
    if (response.success) {
      dispatch(getInbox({ userId: me.id }));
    }
  };

  const isExploreShow =
    selectedInbox.type ===
      InboxType.SPECIFICATION_EXPLORE_MATCHED_PRODUCT_COMPLETED ||
    selectedInbox.type ===
      InboxType.SPECIFICATION_EXPLORE_USER_AND_COMMENT_COMPLETED ||
    selectedInbox.type ===
      InboxType.SPECIFICATION_EXPLORE_LOCAL_PARTNER_SUPPORT_COMPLETED ||
    selectedInbox.type ===
      InboxType.SPECIFICATION_EXPLORE_COMPETITIVE_INDEX_COMPLETED ||
    selectedInbox.type ===
      InboxType.SPECIFICATION_EXPLORE_PRODUCER_SCORE_COMPLETED;

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center p-2">
        <div className="flex items-center gap-2 px-1 ">
          <IconPlusFile />
          <span className="text-sm font-500 text-foreground mt-1">
            {t("specification")}
          </span>
          <ChevronRight size={16} color="#71717A" />
          <span className="text-sm font-500 text-muted-foreground mt-1">
            {selectedInbox?.metadata?.specification?.name}
          </span>
        </div>
        <div className="ml-auto flex items-center gap-1">
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                disabled={!selectedInbox}
                onClick={handleToggleFavorite}
              >
                <Star
                  size={20}
                  fill={selectedInbox.isFavorite ? "#000000" : "none"}
                />
                <span className="sr-only">{t("favorite")}</span>
              </Button>
            </TooltipTrigger>
            <TooltipContent>{t("favorite")}</TooltipContent>
          </Tooltip>

          <AlertDialog
            open={isDeleteDialogOpen}
            onOpenChange={setIsDeleteDialogOpen}
          >
            <AlertDialogTrigger asChild disabled={!selectedInbox}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="ghost"
                    size="icon"
                    disabled={!selectedInbox}
                    onClick={() => setIsDeleteDialogOpen(true)}
                  >
                    <Trash className="h-5 w-5" size={20} />
                    <span className="sr-only">{t("delete")}</span>
                  </Button>
                </TooltipTrigger>
                <TooltipContent>Delete</TooltipContent>
              </Tooltip>
            </AlertDialogTrigger>
            <AlertDialogPortal>
              <AlertDialogContent className="z-[1000]">
                <AlertDialogHeader>
                  <AlertDialogTitle>{t("inbox:delete")}</AlertDialogTitle>
                  <AlertDialogDescription>
                    {t("inbox:delete_description")}
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <Button
                    variant="outline"
                    onClick={() => setIsDeleteDialogOpen(false)}
                  >
                    {t("cancel")}
                  </Button>
                  <Button variant="destructive" onClick={handleDelete}>
                    {t("delete")}
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogPortal>
          </AlertDialog>
        </div>
        <Separator orientation="vertical" className="mx-2 h-6" />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" disabled={!selectedInbox}>
              <MoreVertical className="h-4 w-4" />
              <span className="sr-only">More</span>
            </Button>
          </DropdownMenuTrigger>
          {/* <DropdownMenuContent align="end">
            <DropdownMenuItem>Mark as unread</DropdownMenuItem>
            <DropdownMenuItem>Star thread</DropdownMenuItem>
            <DropdownMenuItem>Add label</DropdownMenuItem>
            <DropdownMenuItem>Mute thread</DropdownMenuItem>
          </DropdownMenuContent> */}
        </DropdownMenu>
      </div>
      <Separator />
      {selectedInbox ? (
        <div className="flex flex-1 flex-col overflow-y-auto scrollbar-hide">
          <div className="flex items-start p-4">
            <div className="flex items-start gap-4 text-sm w-full">
              <div className="grid gap-1 w-full">
                <div className="flex items-center justify-between gap-2">
                  <div className="flex items-center gap-2.5 ">
                    <span
                      className="text-[20px] font-600 text-zinc-950 w-full"
                      dangerouslySetInnerHTML={{ __html: title }}
                    ></span>
                    {isExploreShow && (
                      <Badge
                        variant="secondary"
                        className=" !w-[60px] !text-center bg-green-50 h-[17px] hover:bg-green-50 "
                        style={{
                          border: "1px solid rgba(22, 163, 74, 0.20)",
                        }}
                      >
                        <span className="text-[12px] text-center text-450 text-green-600 w-full">
                          {GetExploreCompletedCount(selectedInbox.type)} / 5
                        </span>
                      </Badge>
                    )}
                  </div>
                  <span className="text-[12px] font-500 text-muted-foreground">
                    {TimeCalculator(
                      selectedInbox.updatedAt || selectedInbox.createdAt,
                      t,
                      true
                    )}
                  </span>
                </div>
                <div className="line-clamp-1">
                  <span
                    className="text-[16px] font-500 text-muted-foreground"
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 whitespace-pre-wrap p-4 text-sm">
            {isExploreShow && <CompletedSpecificationInbox />}
            {selectedInbox?.type === InboxType.SPECIFICATION_INVITE && (
              <InviteSpecificationInbox />
            )}

            {(selectedInbox.type === InboxType.SUPPLIER_SPECIFICATION_INVITE ||
              selectedInbox.type ===
                InboxType.SUPPLIER_SPECIFICATION_INVITE_STARTED ||
              selectedInbox.type ===
                InboxType.SUPPLIER_SPECIFICATION_INVITE_COMPLETED) && (
              <AnsweringSpecificationInbox />
            )}
            <Separator className="my-4" />
            <ActivitySection />
          </div>
        </div>
      ) : (
        <div className="p-8 text-center text-muted-foreground">
          No message selected
        </div>
      )}
    </div>
  );
}
